export const legalIdentity = Object.freeze({
  registeredEntity: "APPING TECHNOLOGY SDN. BHD.",
  registrationNumber: "202001030212 (1386532-X)",
  registeredAddress: [
    "A4-8, Level 4, Block A",
    "Plaza Dwitasik",
    "Jalan 5/106",
    "Bandar Sri Permaisuri",
    "56000 Kuala Lumpur",
    "Wilayah Persekutuan",
    "Malaysia",
  ],
  businessAddress: [
    "P-0313, Impian Meridian",
    "Jalan Subang 1",
    "USJ 1",
    "47600 Subang Jaya",
    "Selangor",
    "Malaysia",
  ],
  contactEmail: "info@appingtechnology.com",
});
